// components/Stepper.js
import React from 'react';


// Componenti SVG importati direttamente dal contenuto dei file SVG
export const Step1SVG: React.FC<{ color: string; fillOpacity: string }> = ({color, fillOpacity}) => (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13 14H5.41548C4.23086 14 3.63856 14 3.11625 14.202C2.84326 14.3076 2.58719 14.4526 2.35619 14.6324C1.91422 14.9763 1.60948 15.4842 1 16.5V5C1 3.11438 1 2.17157 1.58579 1.58579C2.17157 1 3.11438 1 5 1H13C14.8856 1 15.8284 1 16.4142 1.58579C17 2.17157 17 3.11438 17 5V10C17 11.8856 17 12.8284 16.4142 13.4142C15.8284 14 14.8856 14 13 14Z"
            fill="#7E869E" fillOpacity="0.25"/>
        <path
            d="M17 10V15C17 16.8856 17 17.8284 16.4142 18.4142C15.8284 19 14.8856 19 13 19H3.5C2.11929 19 1 17.8807 1 16.5V16.5C1 15.1193 2.11929 14 3.5 14H13C14.8856 14 15.8284 14 16.4142 13.4142C17 12.8284 17 11.8856 17 10V5C17 3.11438 17 2.17157 16.4142 1.58579C15.8284 1 14.8856 1 13 1H5C3.11438 1 2.17157 1 1.58579 1.58579C1 2.17157 1 3.11438 1 5V16.5"
            stroke="#222222" strokeWidth="1.2"/>
        <path d="M6 8L7.29289 9.29289C7.68342 9.68342 8.31658 9.68342 8.70711 9.29289L12 6" stroke="#222222"
              strokeWidth="1.2" strokeLinecap="round"/>
    </svg>

);

export const Step2SVG: React.FC<{ color: string; fillOpacity: string }> = ({color, fillOpacity}) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="18" height="18" rx="2" fill="#7E869E" fillOpacity="0.25" stroke="#222222"/>
        <path
            d="M15 7L11.9558 11.5662C11.5299 12.2051 10.5728 12.1455 10.2294 11.4587L9.77063 10.5413C9.42725 9.8545 8.47006 9.79491 8.04415 10.4338L5 15"
            stroke="#222222" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

);

export const Step3SVG: React.FC<{ color: string; fillOpacity: string }> = ({color, fillOpacity}) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 17L1.6797 7.84963C1.34718 7.43398 1.18092 7.22615 1.13625 6.9757C1.09159 6.72524 1.17575 6.47276 1.34407 5.96778L2.0883 3.73509C2.52832 2.41505 2.74832 1.75503 3.2721 1.37752C3.79587 1 4.49159 1 5.88304 1H12.117C13.5084 1 14.2041 1 14.7279 1.37752C15.2517 1.75503 15.4717 2.41505 15.9117 3.73509L16.6559 5.96778C16.8243 6.47276 16.9084 6.72524 16.8637 6.9757C16.8191 7.22615 16.6528 7.43398 16.3203 7.84963L9 17Z"
            fill="#7E869E" fillOpacity="0.25"/>
        <path
            d="M9 17L1.6797 7.84963C1.34718 7.43398 1.18092 7.22615 1.13625 6.9757C1.09159 6.72524 1.17575 6.47276 1.34407 5.96778L2.0883 3.73509C2.52832 2.41505 2.74832 1.75503 3.2721 1.37752C3.79587 1 4.49159 1 5.88304 1H12.117C13.5084 1 14.2041 1 14.7279 1.37752C15.2517 1.75503 15.4717 2.41505 15.9117 3.73509L16.6559 5.96778C16.8243 6.47276 16.9084 6.72524 16.8637 6.9757C16.8191 7.22615 16.6528 7.43398 16.3203 7.84963L9 17ZM9 17L12.5 6M9 17L5.5 6M16.5 7L12.5 6M12.5 6L11 2M12.5 6H5.5M7 2L5.5 6M5.5 6L1.5 7"
            stroke="#222222" strokeLinecap="round"/>
    </svg>
);

export const Step4SVG: React.FC<{ color: string; fillOpacity: string }> = ({color, fillOpacity}) => (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.577 4.52566L1.65811 1.21937C1.3578 1.11927 1.20764 1.06921 1.10382 1.14405C1 1.21888 1 1.37716 1 1.69371V9L11.577 5.47434C12.1653 5.27824 12.4594 5.18019 12.4594 5C12.4594 4.81981 12.1653 4.72176 11.577 4.52566Z"
            fill="#7E869E" fillOpacity="0.25"/>
        <path
            d="M1 9V1.69371C1 1.37716 1 1.21888 1.10382 1.14405C1.20764 1.06921 1.3578 1.11927 1.65811 1.21937L11.577 4.52566C12.1653 4.72176 12.4594 4.81981 12.4594 5C12.4594 5.18019 12.1653 5.27824 11.577 5.47434L1 9ZM1 9V14V15"
            stroke="#222222" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
)

export const Step5SVG: React.FC<{ color: string; fillOpacity: string }> = ({color, fillOpacity}) => (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 6H19V10C19 11.8856 19 12.8284 18.4142 13.4142C17.8284 14 16.8856 14 15 14H5C3.11438 14 2.17157 14 1.58579 13.4142C1 12.8284 1 11.8856 1 10V6Z"
            fill="#7E869E" fillOpacity="0.25"/>
        <rect x="1" y="1" width="18" height="13" rx="2" stroke="#222222" strokeWidth="1.2"/>
        <path d="M5 10H5.01" stroke="#222222" strokeWidth="1.2" strokeLinecap="round"/>
        <path d="M1 6L19 6" stroke="#222222" strokeWidth="1.2" strokeLinecap="round"/>
        <rect x="1" y="4" width="18" height="2" fill="#222222"/>
    </svg>
);

export const Step6SVG: React.FC<{ color: string; fillOpacity: string }> = ({color, fillOpacity}) => (
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 5V1H5C3.11438 1 2.17157 1 1.58579 1.58579C1 2.17157 1 3.11438 1 5V15C1 16.8856 1 17.8284 1.58579 18.4142C2.17157 19 3.11438 19 5 19H11C12.8856 19 13.8284 19 14.4142 18.4142C15 17.8284 15 16.8856 15 15V7H11C10.0572 7 9.58579 7 9.29289 6.70711C9 6.41421 9 5.94281 9 5Z"
            fill="#7E869E" fillOpacity="0.25"/>
        <path
            d="M9.17157 1H5C3.11438 1 2.17157 1 1.58579 1.58579C1 2.17157 1 3.11438 1 5V15C1 16.8856 1 17.8284 1.58579 18.4142C2.17157 19 3.11438 19 5 19H11C12.8856 19 13.8284 19 14.4142 18.4142C15 17.8284 15 16.8856 15 15V6.82843C15 6.41968 15 6.2153 14.9239 6.03153C14.8478 5.84776 14.7032 5.70324 14.4142 5.41421L10.5858 1.58579C10.2968 1.29676 10.1522 1.15224 9.96847 1.07612C9.7847 1 9.58032 1 9.17157 1Z"
            stroke="#222222" strokeWidth="1.2"/>
        <path d="M5 11L11 11" stroke="#222222" strokeWidth="1.2" strokeLinecap="round"/>
        <path d="M5 15L9 15" stroke="#222222" strokeWidth="1.2" strokeLinecap="round"/>
        <path d="M9 1V5C9 5.94281 9 6.41421 9.29289 6.70711C9.58579 7 10.0572 7 11 7H15" stroke="#222222"
              strokeWidth="1.2"/>
    </svg>
);

export const Step7SVG: React.FC<{ color: string; fillOpacity: string }> = ({color, fillOpacity}) => (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.5447 4.15207L9.63027 1.61734C9.22779 1.44484 8.77221 1.44484 8.36973 1.61734L2.45535 4.15207C1.79996 4.43295 1.40953 5.11362 1.49798 5.82116L2.11096 10.725C2.31853 12.3856 3.14916 13.9053 4.43478 14.9767L7.97571 17.9274C8.56906 18.4219 9.43094 18.4219 10.0243 17.9274L13.5652 14.9767C14.8508 13.9053 15.6815 12.3856 15.889 10.725L16.502 5.82116C16.5905 5.11362 16.2 4.43295 15.5447 4.15207Z"
            fill="#7E869E" fillOpacity="0.25" stroke="#222222" strokeWidth="1.2" strokeLinecap="round"/>
        <path d="M6 10L8.56874 12.5687C8.79184 12.7918 9.16329 12.7551 9.33831 12.4925L13 7" stroke="#222222"
              strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
);

interface StepperProps {
    steps: {
        id: number;
        title: string;
        description: string;
        icon: React.ReactElement;
    }[]
    currentStep: number;
    onStepChange?: (step: number) => void;
    orientation: 'vertical' | 'horizontal'; // Aggiunta dell'orientamento
}

const Stepper = ({steps, currentStep, orientation}: StepperProps) => {


    return (
        <div className={orientation === 'vertical' ? '' : 'flex items-center justify-between'}>
            {steps.map((step, index) => (
                <div key={step.id} className={`flex ${orientation === 'vertical' ? 'flex-col items-start' : 'items-center'}`}>
                    <div className="flex items-center gap-x-2">
                        <div
                            className={`w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all ${
                                currentStep >= step.id
                                    ? 'bg-white border-primary text-primary'
                                    : 'bg-white border-gray-300 text-gray-400'
                            }`}
                        >
                            {step.icon}
                        </div>

                        {orientation === 'vertical' && (
                            <div className="flex flex-col w-full">
                                <h3 className="font-semibold text-primary text-base md:text-lg lg:text-xl">
                                    {step.title}
                                </h3>
                                <p className="text-sm md:text-base lg:text-lg text-gray-600">
                                    {step.description}
                                </p>
                            </div>
                        )}
                    </div>

                    {orientation === 'horizontal' && index < steps.length - 1 && (
                        <div className="w-16 h-1 bg-[#D0E1F6] mx-2"/>
                    )}

                    {orientation === 'vertical' && index < steps.length - 1 && (
                        <div className="w-1 h-6 bg-[#D0E1F6] ml-[18px]"/>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Stepper;

